import {
  aggregate,
  createDirectus,
  createItem,
  deleteItem,
  readItems,
  rest,
  updateItem,
} from '@directus/sdk'
import { Status } from '~/types/footer'

let restAPI = createDirectus(process.env.NEXT_PUBLIC_CMS_URL || '')

export async function search(collection: string | never, query?: any) {
  return await restAPI.with(rest()).request(readItems(collection, query))
}

export async function searchPage(pageName: string) {
  return await restAPI.with(rest()).request(
    readItems('page', {
      filter: {
        status: { _eq: Status.PUBLISHED },
        slug: { _eq: pageName },
      },
      fields: [
        'translations.title',
        'translations.languages_code',
        'section_ids.section_id.type',
        'section_ids.section_id.order',
        'section_ids.section_id.visible',
        'section_ids.section_id.block_id.value_text',
        'section_ids.section_id.block_id.block_type',
        'section_ids.section_id.block_id.key',
        'section_ids.section_id.block_id.value_image',
        'section_ids.section_id.block_id.value_cards.*.*.*',
        'section_ids.section_id.block_id.post_list_value.*',
        'section_ids.section_id.section_definition.code',
        'section_ids.section_id.block_id.template_id.*',
      ],
    })
  )
}

export const sendMail = async (
  collection_name: string,
  valueForm: { fullname: string; mail: string; message: string }
) => {
  return await restAPI.with(rest()).request(createItem(collection_name, valueForm))
}

export async function getTotal(collection: string | never, query?: any) {
  return await restAPI.with(rest()).request(
    aggregate(collection, {
      aggregate: {
        count: '*',
      },
      query: { filter: query },
    })
  )
}

export async function create(collection: string | never, obj?: any) {
  return await restAPI.with(rest()).request(createItem(collection, obj))
}

export async function update(collection: string | never, id: any, obj?: any) {
  return await restAPI.with(rest()).request(updateItem(collection, id, obj))
}

export async function remove(collection: string | never, id?: any) {
  return await restAPI.with(rest()).request(deleteItem(collection, id))
}
